import { PieChartOutlined } from "@ant-design/icons";
import { Button, Form, Input, message, Modal, Select, Tag } from "antd";
import { useForm } from "antd/es/form/Form";
import { toJalaali } from "jalaali-js";
import moment from "moment/moment";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import api from "../../../../api/api";
import DataTable from "../../../../Components/DataTable/DataTable";
import * as actions from "../../../../store/actions/action";
import CheckPermission from "../../../../Util/CheckPermission";
import ConvertNumbersToEn from "../../../../Util/ConvertNumbersToEn";
import ExportExcel from "../../../../Util/ExportExcel";
import { dataFetchError } from "../../../../Util/Messages";
import OrderProductEditor from "./OrderProductEditor";

const UsersReport = ({ LoadingSetter, ClearLoading, loading, permissions }) => {
  const [data, setData] = useState([]);
  const [filtersModal, setFiltersModal] = useState(false);
  const [formList, setFormList] = useState([]);
  const [epollFormList, setEpollFormList] = useState([]);
  const [editingId, setEditingId] = useState();
  const [tags, setTags] = useState([]);
  const [groups, setGroups] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [skipPaymentUsers, setSkipPaymentUsers] = useState([]);
  const [ordersInfo, setOrdersInfo] = useState();
  const [reset, setReset] = useState({});
  const [columns, setColumns] = useState([
    {
      title: "نام",
      dataIndex: "firstname",
      searchable: true,
    },
    {
      title: "نام خانوادگی",
      dataIndex: "lastname",
      searchable: true,
    },
    {
      title: "موبایل",
      dataIndex: "username",
      searchable: true,
      render: (text, record) => {
        return (
          <span
            onClick={() => {
              navigator.clipboard.writeText(record?.username);
              message.success("شماره موبایل در کلیپ بورد کپی شد");
            }}
          >
            {record?.username}
          </span>
        );
      },
    },
    {
      title: "کد کشور",
      dataIndex: "country_code",
      searchable: true,
      render: (text, record) => {
        return <span dir="ltr">{record?.country_code || "98"}</span>;
      },
    },

    {
      title: "ایمیل",
      dataIndex: "email",
      searchable: true,
    },
    {
      title: "وریفای ایمیل",
      dataIndex: "emailVerified",
      render: (text, record) => {
        if (!record.email) return "-";
        return record.emailVerified ? "تایید شده" : "تایید نشده";
      },
      filterMultiple: false,
      filterSearch: true,
      filters: [
        { value: true, text: "تایید شده" },
        { value: false, text: "تایید نشده" },
      ],
      onFilter: (value, record) => {
        if (!record.email) return false;

        const status =
          typeof record.emailVerified === "boolean"
            ? record.emailVerified
            : false;

        return value === status;
      },
    },
    {
      title: "تاریخ ثبت نام",
      dataIndex: "createdAt",
      // defaultSortOrder: "ascend",
      // sorter: (a, b) => {
      //   const Adate = new Date(a.createdAt);
      //   const Bdate = new Date(b.createdAt);

      //   return Bdate - Adate;
      // },
      render: (text, record) => {
        const date = new Date(text);
        if (moment(date).isValid()) {
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "محصولات",
      render: (text, record) => {
        if (record?.ordersInfo?.length === 0) {
          return "بدون محصول";
        }

        return (
          <Button
            onClick={() => {
              console.log({ record });
              setOrdersInfo(record);
            }}
          >
            مشاهده
          </Button>
        );
      },
    },
  ]);
  const [form] = useForm();

  const paymentAmountAccess = useMemo(
    () => CheckPermission("payment_amount", permissions),
    [permissions]
  );

  const resetPermission = useMemo(
    () => CheckPermission("reset_user", permissions),
    [permissions]
  );

  const [advancedFilters, setAdvancedFilters] = useState({
    paymentStatus: null,
    skipPayment: null,
    tag: null,
    group: null,
    gateway: null,
    product: null,
    responseStatus: null,
    published: null,
  });

  const formDropdownOptions = useMemo(() => {
    const planium = formList.map((f) => ({
      label: `پلنیوم: ${f.title}`,
      value: `planium:${f.id}`,
      provider: "planium",
      formId: f.id,
      title: f.title,
    }));
    const epoll = epollFormList.map((f) => ({
      label: `ایپل: ${f.name}`,
      value: `epoll:${f.formId}`,
      provider: "epoll",
      formId: f.formId,
      title: f.name,
    }));
    return [...planium, ...epoll];
  }, [formList, epollFormList]);

  const getRowDropdownValue = (record) => {
    const provider = record?.roadmapFormProvider;
    if (provider === "planium" && record?.roadmapForm?.id != null) {
      return `planium:${record.roadmapForm.id}`;
    }
    if (provider === "epoll" && record?.roadmapForm?.formId != null) {
      return `epoll:${record.roadmapForm.formId}`;
    }
    return undefined;
  };

  const changeUserForm = (roadmapKey, optionValue) => {
    const option = formDropdownOptions.find((o) => o.value === optionValue);
    if (!option) return;

    api
      .put("/forms/user/change", {
        roadmapKey,
        formId: option.formId,
        provider: option.provider,
      })
      .then((res) => {
        setData((prev) =>
          prev.map((el) => {
            if (el.roadmapKey !== roadmapKey) return el;

            return {
              ...el,
              roadmapForm:
                option.provider === "planium"
                  ? { id: option.formId, title: option.title }
                  : { formId: option.formId, title: option.title },
              roadmapFormProvider: option.provider,
            };
          })
        );
        setEditingId();
        message.success("باموفقیت آپدیت شد.");
      })
      .catch(() => message.error("خطا در آپدیت پرسشنامه"));
  };

  useEffect(() => {
    api
      .get("/forms/list-all-providers")
      .then((res) => {
        setFormList(res.data.planium || []);
        setEpollFormList(res.data.epoll || []);
      })
      .catch(() => message.error("خطا در دریافت لیست پرسشنامه ها"));
  }, []);

  useEffect(() => {
    if (CheckPermission("activateOTP", permissions)) {
      setColumns((p) => [
        ...p,
        {
          title: "OTP",
          dataIndex: "otp",
          alignItems: "center",
          filterMultiple: false,
          filters: [
            { value: true, text: "فعال" },
            { value: false, text: "غیر فعال" },
          ],
          render: (text, record) => {
            return (
              <Button
                onClick={() =>
                  toggleOTP(
                    record.id,
                    record.activeOTP === false ? true : false
                  )
                }
              >
                {record.activeOTP === false ? "فعال کردن" : "غیر فعال کردن"}
              </Button>
            );
          },
        },
      ]);
    }
  }, [permissions]);

  useEffect(() => {
    if (CheckPermission("login_as_user", permissions)) {
      setColumns((p) => {
        if (p.some((column) => column.dataIndex === "loginAsUser")) {
          return p;
        }
        return [
          ...p,
          {
            title: "ورود",
            dataIndex: "loginAsUser",
            alignItems: "center",
            render: (text, record) => {
              return (
                <Button onClick={() => loginAsUser(record.id)}>ورود</Button>
              );
            },
          },
        ];
      });
    }
  }, [permissions]);

  const toggleOTP = (userId, active) => {
    LoadingSetter();
    api
      .post("/activateOTP", { active, userId })
      .then((res) => {
        message.success("تغییر وضعیت با موفقیت انجام شد");
        console.log();
        setData((prev) =>
          prev.map((e) => ({
            ...e,
            activeOTP: e.id === userId ? active : e.activeOTP,
          }))
        );
      })
      .catch((err) => {
        message.error("خطا در تغییر وضعیت");
      })
      .finally(() => ClearLoading());
  };

  const loginAsUser = (userId) => {
    const popup = window.open("about:blank", "_blank");
    LoadingSetter();
    api
      .post("/login-code", { userId })
      .then((res) => {
        const code = res.data?.code;
        if (!code) {
          popup?.close();
          message.error("خطا در ورود به عنوان کاربر");
          return;
        }
        const baseUrl =
          process.env.REACT_APP_FRONTEND_BASEURL || "planium.ir";
        const baseUrlWithProtocol = baseUrl.startsWith("http")
          ? baseUrl
          : `https://${baseUrl}`;
        const urlObj = new URL("/logincode", baseUrlWithProtocol);
        urlObj.searchParams.set("code", code);
        if (popup) {
          popup.location.href = urlObj.toString();
        } else {
          window.open(urlObj.toString(), "_blank");
        }
      })
      .catch(() => {
        popup?.close();
        message.error("خطا در ورود به عنوان کاربر");
      })
      .finally(() => ClearLoading());
  };

  const updateOrderProduct = (updatedOrder) => {
    const updateUser = (user) => ({
      ...user,
      ordersInfo: user.ordersInfo?.map((order) =>
        order.orderId === updatedOrder.orderId
          ? { ...order, ...updatedOrder }
          : order
      ),
    });
    setOrdersInfo((user) => (user ? updateUser(user) : user));
    setData((users) => users.map(updateUser));
  };

  const reportCols = [
    {
      title: "وضعیت پرداخت",
      dataIndex: "paymentStatus",

      filters: [
        { value: "NOT_PAID", text: "پرداخت نشده" },
        { value: "PAID", text: "پرداخت شده" },
        { value: "SKIP_PAYMENT", text: "رد از پرداخت" },
      ],
      onFilter: (value, record) => {
        if (value === "SKIP_PAYMENT" && record?.skipPaymentUser?.id) {
          return true;
        }

        return value === record.paymentStatus;
      },
      render: (text, record) => {
        const resetBtn = (
          <Button
            onClick={() => setReset({ id: record.roadmapId, type: "PAYMENT" })}
            style={{ marginTop: "2px" }}
          >
            ریست
          </Button>
        );

        if (record?.skipPaymentUser?.id) {
          return (
            <>
              <Tag color="yellow">رد از پرداخت</Tag>
              {resetPermission && resetBtn}
            </>
          );
        }

        switch (text) {
          case "NOT_PAID":
            return <Tag color="red">پرداخت نشده</Tag>;
          case "PAID":
            return (
              <>
                <Tag color="green">پرداخت شده</Tag>
                {resetBtn}
              </>
            );
          default:
            return text;
        }
      },
    },
    {
      title: "رد از پرداخت",
      dataIndex: "skipPaymentUser",
      filters: [
        { text: "خرید از سایت", value: "ORGANIC" },
        ...skipPaymentUsers?.map((el) => ({
          text: `${el?.firstname} ${el?.lastname}`,
          value: el.id,
        })),
      ],
      onFilter: (val, record) => {
        if (
          val === "ORGANIC" &&
          !record?.skipPaymentUser?.id &&
          record.paymentStatus === "PAID"
        ) {
          return true;
        }

        return record?.skipPaymentUser?.id === val;
      },
      render: (_, record) => {
        if (!record?.skipPaymentUser?.id) return "-";

        return `${record?.skipPaymentUser?.firstname} ${record?.skipPaymentUser?.lastname}`;
      },
    },
    // tag
    {
      title: "تگ",
      dataIndex: "skipPaymentTag",
      searchable: true,
    },
    // group
    {
      title: "گروه",
      dataIndex: "group",
      filters: [
        { text: "پلنیوم", value: "PLANIUM" },
        { text: "رابین", value: "RABIN" },
      ],
      onFilter: (val, record) => {
        return record.group === val;
      },
      render: (val) => {
        if (val === "PLANIUM") return "پلنیوم";
        if (val === "RABIN") return "رابین";

        return "-";
      },
    },
    // gateway
    {
      title: "درگاه",
      dataIndex: "gateway",
      filters: [
        { text: "تارا", value: "RABEEEN_TARA" },
        { text: "پی‌پینگ", value: "PAY_PING" },
        { text: "اسنپ‌پی", value: "SNAPP_PAY" },
        { text: "کارت به کارت", value: "RABEEEN_SAMAN" },
        { text: "زیبال", value: "zibal" },
      ],
      onFilter: (value, record) => {
        const gatewayMap = {
          RABEEEN_TARA: ["RABEEEN_TARA"],
          PAY_PING: ["PAY_PING", "ZEENAJI_PAYPING", "payping", "zify", "C2C"],
          SNAPP_PAY: ["SNAPP_PAY", "SNAPP_PAY_LIMOOME", "ZEENAJI_SNAPP_PAY"],
          RABEEEN_SAMAN: ["RABEEEN_SAMAN", "card-to-card"],
          zibal: ["zibal"],
        };
        return (gatewayMap[value] || []).includes(record.gateway);
      },
      render: (val, record) => {
        if (record.paymentStatus !== "PAID" && !record?.skipPaymentUser?.id) {
          return "-";
        }

        if (val === "RABEEEN_TARA") return "تارا";
        if (val === "C2C") return "پی‌پینگ";
        if (val === "RABEEEN_SAMAN") return "کارت به کارت";
        if (val === "payping") return "پی‌پینگ";
        if (val === "PAY_PING") return "پی‌پینگ";

        if (val === "SNAPP_PAY") return "اسنپ‌پی";
        if (val === "ZEENAJI_SNAPP_PAY") return "اسنپ‌پی";
        if (val === "ZEENAJI_PAYPING") return "پی‌پینگ";
        if (val === "zify") return "پی‌پینگ";
        if (val === "zibal") return "زیبال";
        if (val === "card-to-card") return "کارت به کارت";
        if (val === "SNAPP_PAY_LIMOOME") return "اسنپ‌پی";

        return val;
      },
    },
    // product
    {
      title: "محصول",
      dataIndex: "productTitle",
      width: "10%",
      searchable: true,
      render: (_, record) => (
        <OrderProductEditor
          key={record.orderId}
          order={record}
          canEdit={CheckPermission("change_order_product", permissions)}
          onChanged={updateOrderProduct}
        />
      ),
    },
    // renewal status
    {
      title: "نوع خرید",
      dataIndex: "isRenewal",
      filters: [
        { text: "خرید جدید", value: false },
        { text: "تمدید", value: true },
      ],
      onFilter: (value, record) => {
        return record.isRenewal === value;
      },
      render: (isRenewal) => {
        return isRenewal ? (
          <Tag color="blue">تمدید</Tag>
        ) : (
          <Tag>خرید جدید</Tag>
        );
      },
    },
    // gift sender
    {
      title: "هدیه از",
      dataIndex: "giftSender",
      width: "15%",
      filters: [
        { text: "هدیه", value: true },
        { text: "بدون هدیه", value: false },
      ],
      onFilter: (value, record) => {
        if (value === true) return record.isGift && !!record.giftSender;
        return !record.isGift || !record.giftSender;
      },
      render: (text, record) => {
        if (record.isGift && record.giftSender) {
          return (
            <span>
              {record.giftSender.firstname} {record.giftSender.lastname} (
              {record.giftSender.username})
            </span>
          );
        }
        return "-";
      },
    },
    // form
    {
      title: "پرسشنامه",
      dataIndex: "form",
      width: "10%",
      filters: formDropdownOptions.map((o) => ({
        text: o.label,
        value: o.value,
      })),
      onFilter: (val, record) => getRowDropdownValue(record) === val,
      render: (_, record) => {
        if (editingId === record.id) {
          return (
            <Select
              onChange={(value) => changeUserForm(record.roadmapKey, value)}
              style={{
                width: "100%",
                textAlign: "center",
              }}
              defaultValue={getRowDropdownValue(record)}
              options={formDropdownOptions.map((o) => ({
                label: o.label,
                value: o.value,
              }))}
            />
          );
        }

        const providerPrefix =
          record?.roadmapFormProvider === "epoll"
            ? "ایپل: "
            : record?.roadmapFormProvider === "planium"
              ? "پلنیوم: "
              : "";
        return (
          <span
            style={{ width: "100%" }}
            onClick={() => setEditingId(record.id)}
          >
            {record?.roadmapForm?.title
              ? `${providerPrefix}${record.roadmapForm.title}`
              : "-"}
          </span>
        );
      },
    },
    {
      title: "مبلغ پرداخت شده",
      dataIndex: "paymentAmount",
      searchable: true,
      sorter: (a, b) => {
        const A = isNaN(+a.paymentAmount) ? 0 : +a.paymentAmount;
        const B = isNaN(+b.paymentAmount) ? 0 : +b.paymentAmount;
        return A - B;
      },
      render: (val) => {
        if (!paymentAmountAccess) return "-";
        if (val) {
          return parseInt(val)?.toLocaleString();
        }
        return val;
      },
    },
    // payment date
    {
      title: "تاریخ پرداخت",
      dataIndex: "paymentAt",
      sorter: (a, b) => {
        if (a.paymentAt && b.paymentAt) {
          const Adate = new Date(a.paymentAt);
          const Bdate = new Date(b.paymentAt);
          return Bdate - Adate;
        } else if (a.paymentAt) {
          return 1;
        }
        return -1;
      },
      render: (text, record) => {
        let date = new Date(text);

        if (record?.skipPaymentUser?.id && record?.skipPaymentDate) {
          date = new Date(record?.skipPaymentDate);

          // skip payment date
          if (moment(date).isValid()) {
            const jalali = toJalaali(
              date.getFullYear(),
              date.getMonth() + 1,
              date.getDate()
            );
            return (
              <span dir="ltr">
                {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
                {date.toLocaleTimeString("eo", { hour12: false })}
              </span>
            );
          }
        }

        // real payment date
        if (moment(date).isValid()) {
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "وضعیت پاسخ به سوالات",
      dataIndex: "questionStatus",

      filters: [
        { value: "NOT_ANSWERED", text: "پاسخ داده نشده" },
        { value: "ANSWERED", text: "پاسخ داده شده" },
      ],
      onFilter: (value, record) => {
        return value === record.questionStatus;
      },
      render: (text, record) => {
        switch (text) {
          case "NOT_ANSWERED":
            return <Tag color="red">پاسخ داده نشده</Tag>;
          case "ANSWERED":
            return (
              <>
                <Tag color="green">پاسخ داده شده</Tag>

                {resetPermission && (
                  <Button
                    onClick={() =>
                      setReset({ id: record.roadmapId, type: "ANSWERS" })
                    }
                    style={{ marginTop: "2px" }}
                  >
                    ریست
                  </Button>
                )}
              </>
            );
          default:
            return text;
        }
      },
    },
    {
      title: "تاریخ پاسخ",
      dataIndex: "questionUpdatedAt",
      sorter: (a, b) => {
        if (a.questionUpdatedAt && b.questionUpdatedAt) {
          const Adate = new Date(a.questionUpdatedAt);
          const Bdate = new Date(b.questionUpdatedAt);
          return Bdate - Adate;
        } else if (a.questionUpdatedAt) {
          return 1;
        }
        return -1;
      },
      render: (text, record) => {
        const date = new Date(text);
        if (moment(date).isValid()) {
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "وضعیت انتشار",
      dataIndex: "publishStatus",

      filters: [
        { value: "NOT_PUBLISHED", text: "انتشار نیافته" },
        { value: "PUBLISHED", text: "منتشر شده" },
      ],
      onFilter: (value, record) => {
        return value === record.publishStatus;
      },
      render: (text, record) => {
        switch (text) {
          case "NOT_PUBLISHED":
            return <Tag color="red">انتشار نیافته</Tag>;
          case "PUBLISHED":
            return <Tag color="green">منتشر شده</Tag>;
          default:
            return text;
        }
      },
    },
    {
      title: "تاریخ انتشار",

      dataIndex: "publishedAt",
      sorter: (a, b) => {
        const Adate = new Date(a.publishedAt);
        const Bdate = new Date(b.publishedAt);

        return Bdate - Adate;
      },
      render: (text, record) => {
        const date = new Date(text);
        if (moment(date).isValid()) {
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
  ];

  const loadData = (page = 1, pageSize = 100, filter) => {
    LoadingSetter();
    const mergedFilters = { ...advancedFilters, ...filter };
    const finalFilters = Object.keys(mergedFilters).reduce((acc, key) => {
      if (mergedFilters[key] !== null && mergedFilters[key] !== "") {
        acc[key] = mergedFilters[key];
      }
      return acc;
    }, {});
    api
      .get("/statuses", {
        params: { page, pageSize, ...finalFilters },
      })
      .then((res) => {
        setTags(res.data.distinctTag);
        setGroups(res.data.distinctGroup);
        setData(res.data.data);
        setTotalRecords(res.data.pagination.total);
        ClearLoading();
      })

      .catch((err) => {
        console.log(err);
        ClearLoading();
        dataFetchError();
      });
  };

  const exportData = () => {
    const json = data.map((user) => {
      const newUser = {};
      Object.keys(user).forEach((key) => {
        let title = null;
        columns.forEach((c) => {
          if (c.dataIndex === key) {
            title = c.title;
          }
        });
        if (title) {
          newUser[title] = user[key];
        }
      });
      return newUser;
    });
    ExportExcel(json, "گزارش کاربران");
  };

  const filtersBeautify = (fData) => {
    console.log({ fData });
    return {
      ...(typeof fData.otp?.at(0) === "boolean"
        ? { activeOTP: fData.otp?.at(0) }
        : {}),
      ...(fData.firstname?.at(0) ? { firstname: fData.firstname?.at(0) } : {}),
      ...(fData.lastname?.at(0) ? { lastname: fData.lastname?.at(0) } : {}),
      ...(fData.username?.at(0) ? { phoneNumber: fData.username?.at(0) } : {}),
      ...(fData.country_code?.at(0)
        ? { countryCode: ConvertNumbersToEn(fData.country_code?.at(0)) }
        : {}),
      ...(fData.email?.at(0) ? { email: fData.email?.at(0) } : {}),
    };
  };

  const resetRoadmap = (id, type) => {
    setReset({});
    // type: "ANSWERS" | "PAYMENT"
    api
      .post(`/roadmaps/${id}/reset`, { type })
      .then((res) => message.info("تغییر وضعیت با موفقیت انجام شد"))
      .catch(() => message.error("خطا در تغییر موقعیت"));
  };

  return (
    <>
      <DataTable
        tableKey="users-report"
        recordsCount={totalRecords}
        id="UsersReport"
        filtersBeautify={filtersBeautify}
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        dynamicPagination
        recordCreatorDisabled
        header={{
          title: (
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <span>کاربران</span>
            </div>
          ),
          avatar: { icon: <PieChartOutlined />, size: "large" },
          extra: (
            <>
              {CheckPermission("export_excel", permissions) && (
                <Button onClick={exportData}>خروجی اکسل</Button>
              )}
              {CheckPermission(
                "users_status_list_advanced_search_DISABLED",
                permissions
              ) && (
                <Button onClick={() => setFiltersModal(true)}>
                  فیلتر پیشرفته
                </Button>
              )}
            </>
          ),
        }}
      />

      <Modal
        open={ordersInfo?.id}
        destroyOnClose
        onOk={() => setOrdersInfo()}
        onCancel={() => setOrdersInfo()}
        width={"100%"}
        // fullWidth
      >
        <DataTable
          tableKey="users-report-orders"
          id="UsersOrderReport"
          dataSource={(ordersInfo?.ordersInfo ?? []).map((order) => ({
            ...order,
            id: order.roadmapId ?? order.orderId,
          }))}
          columns={reportCols}
          permissionsPrefix="flags"
          recordCreatorDisabled
          scroll={{ x: 2000 }}
          header={{
            title: <span>{ordersInfo?.firstname}</span>,
          }}
        />
      </Modal>

      {/* advanced filter modal */}
      <Modal
        title="فیلتر پیشرفته"
        open={filtersModal}
        onCancel={() => setFiltersModal(false)}
        destroyOnClose
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={advancedFilters}
          onFinish={(e) => {
            setAdvancedFilters(e);
            console.log({ e });
            loadData(1, 100, e);
            setFiltersModal(false);
          }}
        >
          <Form.Item label="وضعیت پرداخت" name="paymentStatus">
            <Select allowClear placeholder="وضعیت پرداخت">
              <Select.Option value={true}>پرداخت شده</Select.Option>
              <Select.Option value={false}>پرداخت نشده</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="رد کردن از پرداخت" name="skipPayment">
            <Input allowClear placeholder="رد کردن از پرداخت" />
          </Form.Item>

          <Form.Item label="تگ" name="tag">
            <Select allowClear placeholder="تگ">
              {tags.map((tag, i) => (
                <Select.Option key={i} value={tag}>
                  {tag}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="گروه" name="group">
            <Select allowClear placeholder="گروه">
              {groups.map((group, i) => (
                <Select.Option key={i} value={group}>
                  {group}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="درگاه" name="gateway">
            <Select allowClear placeholder="درگاه را انتخاب کنید">
              {[
                { text: "تارا", value: "RABEEEN_TARA" },
                { text: "پی‌پینگ", value: "PAY_PING" },
                { text: "اسنپ‌پی", value: "SNAPP_PAY" },
                { text: "کارت به کارت", value: "RABEEEN_SAMAN" },
              ].map((e) => (
                <Select.Option value={e.value}>{e.text}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="محصول" name="product">
            <Select allowClear placeholder="محصول">
              <Select.Option value="roadmap-3">لایف کوچ</Select.Option>
              <Select.Option value="roadmap-psychology">
                روان‌شناسی
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="وضعیت پاسخ به سوالات" name="responseStatus">
            <Select allowClear placeholder="وضعیت پاسخ به سوالات">
              <Select.Option value={true}>پاسخ داده شده</Select.Option>
              <Select.Option value={false}>پاسخ داده نشده</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="وضعیت انتشار" name="published">
            <Select allowClear placeholder="وضعیت انتشار">
              <Select.Option value={true}>منتشر شده</Select.Option>
              <Select.Option value={false}>منتشر نشده</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              ثبت
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        open={reset?.id}
        destroyOnClose
        title={`آیا از ریست کردن ${
          reset?.type === "ANSWERS" ? "پاسخ" : "پرداخت"
        } مطمئن هستید؟`}
        onOk={() => resetRoadmap(reset.id, reset.type)}
        onCancel={() => setReset({})}
      ></Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UsersReport);
